import * as types from './types';

const INITAL_STATE = {
    minimumDailyPricesByTransMode: {},
    minimumDailyPrices: {},
};

function _updateDailyMinimumPricingForTransMode(state, action) {
    const {
        meta,
        payload,
    } = action;
    const {
        data,
        transMode,
    } = payload;

    const formattedData = data.reduce((acc, item) => {
        const {
            originPlaceId,
            destinationPlaceId,
            date,
            price,
        } = item;

        const existingStateOriginPlacePrice = state.minimumDailyPrices[originPlaceId];
        const existingStateDestinationPlacePrice = existingStateOriginPlacePrice
            && existingStateOriginPlacePrice[destinationPlaceId];
        const existingStateDatePrice = existingStateDestinationPlacePrice
            && existingStateDestinationPlacePrice[date];
        const existingAccOriginPlacePrice = acc[originPlaceId];
        const existingAccDestinationPlacePrice = existingAccOriginPlacePrice
            && existingAccOriginPlacePrice[destinationPlaceId];
        const existingAccDatePrice = existingAccDestinationPlacePrice
            && existingAccDestinationPlacePrice[date];

        acc[originPlaceId] = {
            ...existingStateOriginPlacePrice,
            ...existingAccOriginPlacePrice,
            [destinationPlaceId]: {
                ...existingStateDestinationPlacePrice,
                ...existingAccDestinationPlacePrice,
                meta,
                [date]: {
                    ...existingStateDatePrice,
                    ...existingAccDatePrice,
                    [transMode]: price,
                },
            },
        };

        return acc;
    }, {});

    return {
        ...state,
        minimumDailyPricesByTransMode: {
            ...state.minimumDailyPricesByTransMode,
            ...formattedData,
        },
    };
}

function _updateDailyMinimumPricing(state, action) {
    const {
        meta,
        payload,
    } = action;
    const {
        data,
    } = payload;

    const formattedData = data.reduce((acc, item) => {
        const {
            originPlaceId,
            destinationPlaceId,
            date,
            price,
        } = item;

        const existingStateOriginPlacePrice = state.minimumDailyPrices[originPlaceId];
        const existingStateDestinationPlacePrice = existingStateOriginPlacePrice
            && existingStateOriginPlacePrice[destinationPlaceId];
        const existingStateDatePrice = existingStateDestinationPlacePrice
            && existingStateDestinationPlacePrice[date];
        const existingAccOriginPlacePrice = acc[originPlaceId];
        const existingAccDestinationPlacePrice = existingAccOriginPlacePrice
            && existingAccOriginPlacePrice[destinationPlaceId];
        const existingAccDatePrice = existingAccDestinationPlacePrice
            && existingAccDestinationPlacePrice[date];

        acc[originPlaceId] = {
            ...existingStateOriginPlacePrice,
            ...existingAccOriginPlacePrice,
            [destinationPlaceId]: {
                ...existingStateDestinationPlacePrice,
                ...existingAccDestinationPlacePrice,
                meta,
                [date]: {
                    ...existingStateDatePrice,
                    ...existingAccDatePrice,
                    price,
                },
            },
        };

        return acc;
    }, {});

    return {
        ...state,
        minimumDailyPrices: {
            ...state.minimumDailyPrices,
            ...formattedData,
        },
    };
}

const handlers = {
    [types.SET_DAILY_MINIMUM_PRICING_FOR_TRANS_MODE]: _updateDailyMinimumPricingForTransMode,
    [types.SET_DAILY_MINIMUM_PRICING]: _updateDailyMinimumPricing,
};

function reducer(state = INITAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];
        return handler(state, action);
    }

    return state;
}

export { INITAL_STATE };

export default reducer;
